// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconInvoice: React.FC = () => {
    return (
        <svg
            width="11px"
            height="15px"
            viewBox="0 0 11 15"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            fill="currentColor"
        >
            <g id="Homepage-–-Set" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g
                    id="1-3D-–-Homepage-:-Authenticated"
                    transform="translate(-1182.000000, -1005.000000)"
                    fill="currentColor"
                    fillRule="nonzero"
                >
                    <g transform="translate(34.000000, 682.000000)">
                        <g transform="translate(0.000000, 304.000000)">
                            <g transform="translate(1136.000000, 0.000000)">
                                <g transform="translate(12.000000, 16.000000)">
                                    <g transform="translate(0.000000, 3.750000)">
                                        <path d="M7,0 L7,3.5 L10.5,3.5 L7,0 Z M7.875,7 L2.625,7 L2.625,8.75 L7.875,8.75 L7.875,7 Z M6.125,3.5 L6.125,0 L1.3125,0 C0.587617338,0 0,0.58761692 0,1.3125 L0,12.6875 C0,13.4121094 0.587617338,14 1.3125,14 L9.1875,14 C9.91238308,14 10.5,13.4123831 10.5,12.6875 L10.5,4.375 L7.02460921,4.375 C6.51601571,4.375 6.125,3.98398471 6.125,3.5 Z M1.75,1.96875 C1.75,1.84925795 1.84925795,1.75 1.96875042,1.75 L4.15625042,1.75 C4.27656275,1.75 4.37500042,1.84925795 4.37500042,1.96875 L4.37500042,2.40625 C4.37500042,2.52601576 4.27656275,2.625 4.15625042,2.625 L1.96875042,2.625 C1.84925795,2.625 1.75,2.52601576 1.75,2.40625 L1.75,1.96875 Z M1.75,3.71875 C1.75,3.59843767 1.84925795,3.5 1.96875042,3.5 L4.15625042,3.5 C4.27656275,3.5 4.37500042,3.59843767 4.37500042,3.71875 L4.37500042,4.15625 C4.37500042,4.27656233 4.27656275,4.375 4.15625042,4.375 L1.96875042,4.375 C1.84925795,4.375 1.75,4.27656233 1.75,4.15625 L1.75,3.71875 Z M8.75,12.03125 C8.75,12.1508789 8.65087891,12.25 8.53125,12.25 L6.34375,12.25 C6.22343767,12.25 6.125,12.1515623 6.125,12.03125 L6.125,11.59375 C6.125,11.4741211 6.22412109,11.375 6.34375,11.375 L8.53125,11.375 C8.65087891,11.375 8.75,11.4741211 8.75,11.59375 L8.75,12.03125 Z M8.74999958,6.5625 L8.74999958,9.1875 C8.74999958,9.43017578 8.55517578,9.625 8.3125,9.625 L2.1875,9.625 C1.94496065,9.625 1.74999958,9.43085921 1.74999958,9.1875 L1.74999958,6.5625 C1.74999958,6.31914079 1.94496065,6.125 2.1875,6.125 L8.3125,6.125 C8.55585921,6.125 8.74999958,6.31914079 8.74999958,6.5625 Z"></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default React.memo(IconInvoice);
